<template>
  <div class="flex px-6 sm:px-4 md:px-8 py-6 bg-neutral_600 rounded-[16px] flex-col gap-2 sm:gap-4">
    <div class="flex justify-between">
      <div class="flex items-center">
        <div class="flex items-center gap-2 sm:gap-4">
          <img
            :src="props.bettingShop.logo"
            class="w-[32px] sm:w-[72px]"
            :alt="`${props.bettingShop.name} logo`"
          />
          <p
            class="text-base leading-[150%] sm:text-[22px] md:text-[32px] text-base_white font-bold sm:leading-[120%]"
          >
            {{ props.bettingShop.name }}
          </p>
        </div>
      </div>
      <div class="flex items-center gap-3">
        <p
          v-if="!commonStore.isMobile"
          class="text-base_white text-[12px] font-medium leading-[150%]"
        >
          {{ $t('grades').toLocaleLowerCase() }} - {{ props.bettingShop.reviewCount }}
        </p>
        <!-- <ClientOnly>
          <StarRating
            :star-size="32"
            :padding="4"
            inactive-color="#fff"
            active-color="#86C232"
            :read-only="true"
            :show-rating="false"
            :rating="props.bettingShop.avgScore"
          />
        </ClientOnly> -->
        <BoneRating
          :size="commonStore.isTablet ? 'md' : 'lg'"
          :rating="props.bettingShop.avgScore"
        />
        <p class="text-[18px] text-base_white font-medium leading-[130%] tracking-[-0.36px]">
          {{ props.bettingShop.avgScore.toFixed(1) }}
        </p>
      </div>
    </div>
    <div class="h-px w-full bg-primary_800" />
    <div class="flex flex-col gap-2 md:gap-4 sm:px-4 py-2">
      <div
        v-for="(grade, index) in props.bettingShop.avgValues"
        :key="index"
        class="flex flex-col gap-4"
      >
        <BettingShopGradeSection :grade="grade" />
        <div
          v-if="index != props.bettingShop.avgValues.length - 1"
          class="h-px w-full bg-primary_950 sm:bg-neutral_600"
        />
      </div>
    </div>
    <div class="h-px w-full bg-primary_800" />
    <div class="flex items-center justify-between sm:justify-center">
      <p
        v-if="commonStore.isMobile"
        class="px-3 shrink-0 py-2 text-[12px] text-neutral_200 font-medium leading-[150%]"
      >
        {{ $t('grades') }}
        {{ props.bettingShop.reviewCount }}
      </p>
      <ButtonComponent
        class="shrink-0"
        :text="`${$t('gradeAndCommentBettingShop')}`"
        :size="commonStore.isMobile ? 'sm' : 'md'"
        :font-thickness="commonStore.isMobile ? 'font-normal' : 'font-medium'"
        :cropped="true"
        @click="emits('open-bar')"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import type { BettingShop } from '~/interfaces';
import { useCommonStore } from '~/store/commonStore';
// import StarRating from 'vue-star-rating';

const props = defineProps({
  bettingShop: {
    type: Object as PropType<BettingShop>,
    required: true
  }
});
const emits = defineEmits(['open-bar']);
const commonStore = useCommonStore();
</script>
